import BASE_URL from '../../config/env';
import {apiClient} from '../apiClient';
import {
  IGetMySearchTreeDetailsResponse,
  IGetAdvancedSearchTabsDataResponse,
  EditSavedSearchNewRequest,
  IGetSearchCountResponse,
  IRunBackgroundSearchQueueRequest,
  IRunBackgroundSearchQueueResponse,
} from '../types/searchType.type';

const searchEndpoint = (path: string) =>
  `${BASE_URL}/searching/api/v1/search${path}`;

export const getMySearchTreeDetails =
  async (): Promise<IGetMySearchTreeDetailsResponse> => {
    const {data} = await apiClient.get(searchEndpoint('/tree/my'));
    return data;
  };

export type ButtonType = 'METADATALIST' | 'COMMENTS';

export const getAdvancedSearchTabsData = async (
  buttonType: ButtonType
): Promise<IGetAdvancedSearchTabsDataResponse> => {
  const {data} = await apiClient.get(
    searchEndpoint(`/tabs/data?buttonType=${buttonType}`)
  );
  return data;
};

export const getEditSavedSearchNew = async (
  payload: EditSavedSearchNewRequest
) => {
  const {data} = await apiClient.post(
    searchEndpoint('/edit/savedsearch'),
    payload
  );
  return data;
};

export const getCompletedSavedSearchId = async (
  SearchGroupId: number
): Promise<any> => {
  const {data} = await apiClient.get(
    searchEndpoint(`/background/completed?SearchGroupId=${SearchGroupId}`)
  );
  return data;
};

export const getSearchCount = async (
  searchGroupId: number
): Promise<IGetSearchCountResponse> => {
  const {data} = await apiClient.get(
    searchEndpoint(`/background/count?searchGroupId=${searchGroupId}`)
  );
  return data;
};

export const runBackgroundSearchQueue = async (
  payload: IRunBackgroundSearchQueueRequest
): Promise<IRunBackgroundSearchQueueResponse> => {
  const {data} = await apiClient.post(
    searchEndpoint('/background/queue'),
    payload
  );
  return data;
};
